import type { ReactNode } from 'react';
import type { StatusTone } from '../../status-colors.ts';
import styles from './Badge.module.css';

export const Badge = ({ tone = 'neutral', children }: { tone?: StatusTone; children: ReactNode }) => (
  <span className={[styles['badge'], styles[tone]].join(' ')}>{children}</span>
);
